import { Schema } from "../../../core/render/logic/Markdoc/index";

export const module: Schema = {
	render: "Module",
	attributes: {
		id: { type: String },
	},
};
